import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CursorBox = function CursorBox(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M21 9.5V7.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 3 17.8802 3 16.2 3H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.2798 3 6.1198 3 7.8v8.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 21 6.1198 21 7.8 21h1.7m7.8862-3.2887-1.6983 3.154c-.2776.5155-.4164.7733-.5856.8406a.5.5 0 0 1-.4472-.0391c-.155-.0956-.247-.3735-.431-.9293l-2.7237-8.2262c-.1612-.4868-.2418-.7301-.1838-.8922a.5.5 0 0 1 .3025-.3025c.1621-.058.4054.0226.8922.1838l8.2261 2.7237c.5559.1841.8338.2761.9294.431a.5.5 0 0 1 .039.4473c-.0672.1691-.325.3079-.8406.5855l-3.1539 1.6983c-.0785.0423-.1178.0635-.1522.0906a.5.5 0 0 0-.0823.0823c-.0271.0344-.0483.0737-.0906.1522"
    })
  }));
};
export default CursorBox;